import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { SearchModule } from 'app/layout/common/search/search.module';
import { ThinLayoutComponent } from 'app/layout/layouts/vertical/thin/thin.component';
import { MatSidenavModule } from '@angular/material/sidenav';

@NgModule({
    exports: [
        ThinLayoutComponent
    ], imports: [RouterModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatSidenavModule,
    SearchModule,
    ThinLayoutComponent], providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())] })
export class ThinLayoutModule {
}
